import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ContactsVerify from './ContactsVerify';

import { Button, RadioButton, Typography } from '@vivaahealth/design-system';

import styles from './index.module.css';

import { ContactMethod } from './types';

interface Props {
  email: string | null;
  phoneNumber: string | null;
  code?: string;
  handleGenerateCode: (
    args:
      | { email: string; phoneNumber?: undefined }
      | { email?: undefined; phoneNumber: string },
  ) => Promise<void>;
  login: () => Promise<void>;
  setCode: (code?: string) => void;
}

const Contacts: React.FC<Props> = (props) => {
  const { email, phoneNumber, setCode } = props;
  const [contactMethod, setContactMethod] = useState<ContactMethod>('none');
  const [showVerify, setShowVerify] = useState(false);
  const { t } = useTranslation('login');

  useEffect(() => {
    if (!email) {
      setContactMethod('sms');
      setShowVerify(true);
    } else if (!phoneNumber) {
      setContactMethod('email');
      setShowVerify(true);
    }
  }, [email, phoneNumber, setContactMethod, setShowVerify]);
  const backToContactPage = () => {
    setCode(undefined);
    setContactMethod('none');
    setShowVerify(false);
  };
  if (showVerify) {
    return (
      <ContactsVerify
        {...props}
        contactMethod={contactMethod}
        backToContactPage={backToContactPage}
      />
    );
  }
  return (
    <>
      <div className={styles['description-container']}>
        <Typography variant="paragraph-large">
          {t('selectMethodToSendCode')}
        </Typography>
      </div>
      <div className={styles['radio-button-group']}>
        {
          <RadioButton
            readOnly
            label={t('sendViaTextMessage')}
            name="radio-button-sms"
            checked={contactMethod === 'sms'}
            onClick={() => setContactMethod('sms')}
          />
        }
        <RadioButton
          readOnly
          label={t('sendViaEmail')}
          name="radio-button-email"
          checked={contactMethod === 'email'}
          onClick={() => setContactMethod('email')}
        />
      </div>
      <Button
        disabled={contactMethod === 'none'}
        fullWidth
        size="medium"
        onClick={() => setShowVerify(true)}
      >
        {t('sendCode')}
      </Button>
    </>
  );
};

export default Contacts;
